import { gql } from '@apollo/client'

export const SEARCH_CONTACTS_FOR_SIGNER = gql`
  query SearchContactsForSigner($name: String, $first: Int) {
    allContacts(name: $name, first: $first) {
      edges {
        node {
          id
          fullName
          phone
          email
        }
      }
    }
  }
`

const TEMPLATE_FIELDS = gql`
  fragment TemplateFields on pdf_document_template_node {
    id
    name
    description
    pdfFileUrl
    fieldDefinitions
    signerRoles
    status
    language
    envelopesCount
    created
    user {
      id
      firstName
      lastName
      email
    }
  }
`

export const GET_ALL_PDF_DOCUMENT_TEMPLATES = gql`
  ${TEMPLATE_FIELDS}
  query GetAllPdfDocumentTemplates(
    $first: Int
    $offset: Int
    $status: String
    $name: String
  ) {
    allPdfDocumentTemplates(
      first: $first
      offset: $offset
      status: $status
      name: $name
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...TemplateFields
        }
      }
    }
  }
`

export const GET_ALL_PDF_DOCUMENT_TEMPLATES_ACTIVE = gql`
  query GetAllPdfDocumentTemplatesActive($name: String) {
    allPdfDocumentTemplates(status: "ACTIVE", name: $name) {
      edges {
        node {
          id
          name
          description
          pdfFileUrl
          fieldDefinitions
          signerRoles
        }
      }
    }
  }
`

export const GET_ONE_PDF_DOCUMENT_TEMPLATE = gql`
  query GetOnePdfDocumentTemplate($id: String!) {
    pdfDocumentTemplateById(id: $id) {
      id
      name
      description
      pdfFileUrl
      fieldDefinitions
      signerRoles
      status
      language
      created
      updated
      user {
        id
        firstName
        lastName
      }
    }
  }
`

export const GET_ALL_PDF_ENVELOPES = gql`
  query GetAllPdfEnvelopes($status: String, $templateId: String) {
    allPdfEnvelopes(status: $status, templateId: $templateId) {
      id
      title
      status
      signingOrder
      created
      template {
        id
        name
      }
      agent {
        id
        firstName
        lastName
      }
      user {
        id
        firstName
        lastName
      }
      signers {
        id
        role
        signingOrderIndex
        recipientName
        recipientEmail
        status
        signedOn
      }
    }
  }
`

export const GET_ONE_PDF_ENVELOPE = gql`
  query GetOnePdfEnvelope($id: String!) {
    pdfEnvelopeById(id: $id) {
      id
      title
      status
      signingOrder
      created
      template {
        id
        name
        fieldDefinitions
        signerRoles
        pdfFileUrl
      }
      lead { id }
      policy { id }
      contact { id }
      agent { id firstName lastName }
      user { id firstName lastName }
      signers {
        id
        role
        signingOrderIndex
        recipientName
        recipientEmail
        recipientPhone
        status
        token
        signedOn
        signatureImageUrl
      }
      logs {
        id
        action
        contact
        ipAddress
        region
        browser
        isMobile
        created
        user { id firstName lastName }
      }
    }
  }
`

export const GET_PDF_ENVELOPE_SIGNER_BY_TOKEN = gql`
  query GetPdfEnvelopeSignerByToken($token: String!) {
    pdfEnvelopeSignerByToken(token: $token) {
      id
      role
      recipientName
      status
      token
      envelope {
        id
        title
        signingOrder
        template {
          id
          fieldDefinitions
          signerRoles
          pdfFileUrl
        }
      }
    }
  }
`
